import Container from 'components/ui/Container';
import { useState } from 'react';
// import './style.css';
import TrainningRequestTable from './RequestTable';

const TrainningRequest = () => {
  const [tabValue, setTabValue] = useState<string>('pending');
  const [allID, setAllID] = useState<Array<string>>([]);

  return (
    <Container title="Trainning Request">
      <div className="d-flex flex-column">
        <TrainningRequestTable allID={allID} setAllID={setAllID} />
      </div>
    </Container>
  );
};

export default TrainningRequest;
